import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ActiveExperimentsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ActiveExperimentsQuery = {
  activeExperiments: Array<{
    __typename: 'ActiveExperiment';
    location: string;
    name: string;
    variants: Array<string>;
  }>;
};

export const ActiveExperimentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActiveExperiments' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeExperiments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variants' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActiveExperimentsQuery, ActiveExperimentsQueryVariables>;
